import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmtWhen = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};

export default function PlatformAudit() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/platform/audit-logs").then(({ data }) => setRows(data));
  }, []);

  return (
    <div className="space-y-6" data-testid="platform-audit-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">Audit Trail</h1>
        <p className="mt-1 text-sm text-slate-500">
          Every superadmin action — sign-ins, plan changes, suspensions, announcements
        </p>
      </div>

      <div className="overflow-x-auto rounded-md border border-slate-200 bg-white">
        <table className="w-full text-sm" data-testid="platform-audit-table">
          <thead className="bg-slate-50 text-[11px] uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-2.5 text-left font-semibold">When</th>
              <th className="px-3 py-2.5 text-left font-semibold">Admin</th>
              <th className="px-3 py-2.5 text-left font-semibold">Action</th>
              <th className="px-3 py-2.5 text-left font-semibold">Target</th>
              <th className="px-4 py-2.5 text-left font-semibold">Detail</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-slate-50 transition-colors duration-150">
                <td className="whitespace-nowrap px-4 py-2.5 text-xs text-slate-600">
                  {fmtWhen(r.created_at)}
                </td>
                <td className="px-3 py-2.5 text-xs">{r.admin_name}</td>
                <td className="px-3 py-2.5">
                  <span className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[10px]">
                    {r.action}
                  </span>
                </td>
                <td className="px-3 py-2.5 text-xs text-slate-600">
                  {r.entity_label || r.entity_id || "—"}
                </td>
                <td className="px-4 py-2.5 text-xs text-slate-500">{r.detail || "—"}</td>
              </tr>
            ))}
            {!rows.length && (
              <tr>
                <td colSpan={5} className="px-4 py-14 text-center text-sm text-slate-500">
                  Nothing logged yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
